import ToggleButton from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';

export const FilterButton = styled(ToggleButton)`
  &.MuiToggleButton-root {
    padding-bottom: 3px;
    padding-top: 3px;
  }
`;
